module.exports = __webpack_public_path__ + "img/drag-handle.966ca205.svg";